module.exports = __webpack_public_path__ + "img/lens-167-plus-03.35ace44b.png";